
    var items = document.querySelectorAll('.container-navbar-grey ul li');

    function showItems() {
        items.forEach(function(item, index) {
            setTimeout(function() {
                item.classList.add('active');
            }, index * 1000); // Ajusta el tiempo de espera según tu preferencia
        });
    }

    showItems();

    setInterval(function() {
        var activeItem = document.querySelector('.container-navbar-grey ul li.active');
        activeItem.classList.remove('active');
        var nextItem = activeItem.nextElementSibling;
        if (!nextItem) {
            nextItem = items[0];
        }
        nextItem.classList.add('active');
    }, 3000); // Cambia el elemento cada 3 segundos, ajusta según tu preferencia
 